import { BROADCAST_URL, RTMP_SERVER, studioApi } from "../../api";
import useClipboard from "../../utils";
import useBucketStore from "../../store";
import { IVideo } from "../../interfaces";
import { ICourse } from "../../screens/list";
import moment from "moment";
import { message, Select } from "antd";

export type IPLayer = "old" | "new";
export type IURL = { label: string; value: string };

interface IProps {
  player: "old" | "new";
  setPlayer: (player: "old" | "new") => void;
  latest: IVideo;
  course: ICourse;
  playerUrls: IURL[];
  onChangeUrl: any;
  activeUrl: IURL;
}

export default function VideoDetail({
  player,
  setPlayer,
  latest,
  course,
  playerUrls,
  activeUrl,
  onChangeUrl,
}: IProps) {
  const { copy } = useClipboard();
  const { buckets } = useBucketStore();

  const handleChangeBucket = async (bucket: string) => {
    if (latest.status === "rendering" || latest.status === "rendered") {
      return message.error(
        "Sorry, you can't change the bucket because the class is rendering."
      );
    }
    try {
      await studioApi.put(`videos/${latest._id}`, { bucket });
      message.success("Bucket updated successfully.");
    } catch (e: any) {
      message.error(e.message);
    }
  };
  if (!latest._id || !activeUrl?.value) return <div />;


  return (
    <div className="w-full border mt-1 border-slate-200 bg-white shadow-sm overflow-hidden text-sm text-slate-700">
      <div className="divide-y divide-slate-100">
        <div className="grid grid-cols-7 items-center px-4 py-2.5">
          <div className="text-blue-900 font-semibold col-span-1">Title</div>
          <div className="col-span-3 text-slate-900">{latest.title}</div>
        </div>
        <div className="grid grid-cols-7 items-center px-4 py-2.5">
          <div className="font-semibold text-blue-800 col-span-1">
            Scheduled At
          </div>
          <div className="col-span-3 font-mono text-slate-900">
            {moment(latest.schedule_at).format("DD-MM-YY HH:mm:ss")}
          </div>
        </div>

        <div className="grid grid-cols-7 items-center px-4 py-2.5">
          <div className="text-blue-900 font-semibold col-span-1">Course</div>
          <div className="col-span-3 font-medium text-slate-900">
            {course?.title}
          </div>
        </div>
        <div className="grid grid-cols-7 items-center px-4 py-2.5">
          <div className="text-blue-900 font-semibold col-span-1">
            Stream Key
          </div>
          <div className="col-span-2 flex items-center gap-2">
            <span className="bg-green-100 border border-green-500 rounded-md px-3 py-0.5 text-xs select-all truncate">
              {latest.stream_key}
            </span>
            <button
              onClick={() => copy(latest.stream_key, "Stream key copied")}
              className="shrink-0 px-2.5 py-1 text-xs font-medium border border-slate-200 rounded hover:bg-slate-50 active:bg-slate-100 transition cursor-pointer"
            >
              Copy
            </button>
          </div>
        </div>
        <div className="grid grid-cols-7 items-center px-4 py-2.5">
          <div className="text-blue-900 font-semibold col-span-1">
            Broadcast URL
          </div>
          <div className="col-span-4 flex items-center gap-2">
            <span className="font-mono text-xs text-slate-600 truncate">
              {BROADCAST_URL}
            </span>
            <button
              onClick={() => copy(BROADCAST_URL, "Broadcast key copied")}
              className="shrink-0 px-2.5 py-1 text-xs font-medium border border-slate-200 rounded hover:bg-slate-50 active:bg-slate-100 transition cursor-pointer"
            >
              Copy
            </button>
          </div>
        </div>
        <div className="grid grid-cols-7 items-center px-4 py-2.5">
          <div className="text-blue-900 font-semibold col-span-1">
            Stream URL
          </div>
          <div className="col-span-4 flex items-center gap-2">
            <span className="font-mono text-xs text-slate-600 truncate">
              {latest?.status === "rendered"
                ? latest?.video_url
                : latest?.videoType === "youtube"
                ? latest?.liveUrl
                : `${RTMP_SERVER}/hls/${latest.stream_key}.m3u8`}
            </span>
            <button
              onClick={() =>
                copy(
                  `${RTMP_SERVER}/hls/${latest.stream_key}.m3u8`,
                  "Stream Url copied"
                )
              }
              className="shrink-0 px-2.5 py-1 text-xs font-medium border border-slate-200 rounded hover:bg-slate-50 active:bg-slate-100 transition cursor-pointer"
            >
              Copy
            </button>
          </div>
        </div>
        {/* <div className="grid grid-cols-4 items-center px-4 py-2.5">
          <div className="text-blue-900 font-semibold col-span-1">
            Change Player
          </div>

          <div className="col-span-3">
            <Select
              value={player}
              showSearch
              size="small"
              style={{ width: "100%", maxWidth: "320px" }}
              onSelect={(value: IPLayer) => {
                setPlayer(value);
              }}
              options={[
                {
                  label: "New Player",
                  value: "new",
                },
                {
                  label: "Old Player",
                  value: "old",
                },
              ]}
            />
          </div>
        </div> */}
        <div className="grid grid-cols-7 items-center px-4 py-2.5">
          <div className="text-blue-900 font-semibold col-span-1">
            Change Video
          </div>
          <div className="col-span-3">
            <Select
              value={activeUrl?.value}
              showSearch
              size="small"
              style={{ width: "100%", maxWidth: "320px" }}
              onSelect={onChangeUrl}
              options={playerUrls}
              placeholder="Select video source"
            />
          </div>
        </div>
        {latest?.videoType !== "youtube" && (
          <div className="grid grid-cols-7 items-center px-4 py-2.5">
            <div className="text-blue-900 font-semibold col-span-1">
              Selected Bucket
            </div>
            <div className="col-span-3">
              <Select
                defaultValue={latest.bucket}
                showSearch
                disabled={
                  latest.status === "rendering" || latest.status === "rendered"
                }
                placeholder="Select where to store"
                style={{ width: "100%", maxWidth: "320px" }}
                size="small"
                onSelect={(value) => handleChangeBucket(value)}
                options={buckets?.map((val) => ({
                  value: val?._id,
                  label: val?.title,
                }))}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
